/**
 * Get a Leaflet LatLng location for a marker with potential offset
 * @param markerLocation
 * @param map
 * @param padding
 * @returns Leaflet.LatLng
 */
export var getTargetLocation = function getTargetLocation(markerLocation, map) {
  var zoomScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var padding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    x: 0,
    y: 0
  };
  var containerPoint = map.latLngToContainerPoint(markerLocation);
  var x = containerPoint.x - padding.x * zoomScale;
  var y = containerPoint.y - padding.y * zoomScale;
  return map.containerPointToLatLng([x, y]);
};

/**
 * Get a Leaflet LatLng location for the center of a popup which is above a marker
 * This only works on conventional popups that hover above markers
 * For different kinds of popups a custom targeting method is required
 * @param markerLocation
 * @param map
 * @param popupHeight
 * @param padding
 * @returns Leaflet.LatLng
 */
export var getTargetLocationFocusedOnPopup = function getTargetLocationFocusedOnPopup(markerLocation, map) {
  var popupHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var zoomScale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var padding = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    x: 0,
    y: 0
  };
  var containerPoint = map.latLngToContainerPoint(markerLocation);
  var x = containerPoint.x - padding.x * zoomScale;
  var y = containerPoint.y - (padding.y * zoomScale + popupHeight / 2 * zoomScale);
  return map.containerPointToLatLng([x, y]);
};
export default {
  getTargetLocation: getTargetLocation,
  getTargetLocationFocusedOnPopup: getTargetLocationFocusedOnPopup
};